import React, { useEffect } from 'react';
import { COURSE_CALENDAR_URL } from './courseCalendarTracking';

const openProviderCalendar = (url) => window.location.replace(url);

/** Compatibility for the /book URL already published in crawler snapshots.
 * Current course buttons link directly to Calendly. This old URL never waits
 * for analytics or a backend; retain it for existing cached links. */
export default function CourseBookingPage({ openCalendar = openProviderCalendar }) {
  useEffect(() => {
    openCalendar(COURSE_CALENDAR_URL);
  }, [openCalendar]);
  return <a href={COURSE_CALENDAR_URL}>Open Calendly</a>;
}
